import { favoriteAuditsController } from '@cdab/scania/qpr/offline/controllers'
import type { FavoriteAuditModel } from '@cdab/scania/qpr/offline/models'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsIcon, TdsToast, TdsTooltip } from '@scania/tegel-react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { IconWrapper } from './print-favorite-audit-icon.styles'

export interface FavoriteAuditIconButtonProps {
  favoriteAudit: FavoriteAuditModel | undefined
  auditId: FavoriteAuditModel['auditId']
}

export const FavoriteAuditIconButton = observer(
  function FavoriteAuditIconButton({
    auditId,
    favoriteAudit
  }: FavoriteAuditIconButtonProps) {
    const { t } = useTranslation(['favoriteAudits', 'common'])
    const isFavorite = !!favoriteAudit?.id

    const onClickIsFavorite = async () => {
      if (favoriteAudit?.id !== null) {
        await favoriteAuditsController.Remove(auditId)
        toast(
          <TdsToast
            variant='information'
            header={capitalizeFirstLetter(t('removed.headline'))}
            subheader={t('removed.subheadline', {
              ns: 'favoriteAudits'
            })}
          />
        )
      } else {
        await favoriteAuditsController.Add(auditId)
        toast(
          <TdsToast
            variant='success'
            header={capitalizeFirstLetter(t('added.headline'))}
            subheader={t('added.subheadline', {
              ns: 'favoriteAudits'
            })}
          />
        )
      }
    }

    return (
      <span onClick={onClickIsFavorite}>
        <TdsTooltip
          placement='top'
          selector='#favorite'
          text={isFavorite ? t('icon.remove') : t('icon.add')}
        />

        <IconWrapper id='favorite' isFavorite={isFavorite}>
          {isFavorite ? (
            <TdsIcon name='heart' size='lg' />
          ) : (
            <TdsIcon name='heart_inactive' size='lg' />
          )}
        </IconWrapper>
      </span>
    )
  }
)
